import { createAction, props } from '@ngrx/store';

import { Playlist } from '../models/playlist';
import { SciencePlaylistProblem, EnglishPlaylistProblem, NationalLanguagePlaylistProblem, HistoryPlaylistProblem } from '../models/problem';
import { FindPlaylistProblemsRequest } from '../models/find-playlist-problems-request';

// findPlaylists ------------------------------------------------------------
export const findPlaylists = createAction('[Playlist] Find Play Lists');
export const findPlaylistsSuccess = createAction('[Playlist] Find Play Lists Success', props<{ playlists: Playlist[] }>());
export const findPlaylistsFailure = createAction('[Playlist] Find Play Lists Failure');

// findPlaylistProblemIds ------------------------------------------------------------
export const findPlaylistProblemIds = createAction(
  '[Playlist] Find English Playlist Problem Ids',
  props<{ subjectId: string; playlistId: string }>()
);

export const findPlaylistProblemIdsSuccess = createAction(
  '[Playlist] Find Playlist Problem Ids Success',
  props<{ playlistProblemIds: string[] }>()
);
export const findPlaylistProblemIdsFailure = createAction('[Playlist] Find Playlist Problem Ids Failure');
export const initializePlaylistProblemIdsState = createAction('[Playlist] Initialize Playlist Problem Ids State');

// findPlaylistProblems ------------------------------------------------------------
export const findPlaylistProblems = createAction('[Playlist] Find Playlist Problems', props<FindPlaylistProblemsRequest>());
export const findPlaylistProblemsSuccess = createAction(
  '[Playlist] Find Playlist Problems Success',
  props<{
    subjectId: string;
    playlistProblems: EnglishPlaylistProblem[] | SciencePlaylistProblem[] | HistoryPlaylistProblem[] | NationalLanguagePlaylistProblem[];
  }>()
);
export const findPlaylistProblemsFailure = createAction('[Playlist] Find Playlist Problems Failure');
export const initializePlaylistProblemsState = createAction('[Playlist] Initialize Playlist Problems State');

// findPdfUrl ------------------------------------------------------------
export const resolvePdfObjectUrl = createAction('[Playlist] Resolve Pdf Object Url', props<{ pdfPath: string }>());
export const resolvePdfObjectUrlSuccess = createAction(
  '[Playlist] Resolve Pdf Object Url Success',
  props<{ pdfPath: string; objectUrl: string }>()
);
export const resolvePdfObjectUrlFailure = createAction('[Playlist] Resolve Pdf Object Url Failure', props<{ pdfPath: string }>());
export const initializePdfObjectUrl = createAction('[Playlist] Initialize Pdf Object Url', props<{ pdfPath: string }>());
export const initializePdfObjectUrlState = createAction('[Playlist] Initialize Pdf Object Url State');
